import React, { useContext } from 'react';
import { ProductTransaction, ProductTransactionType } from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../../types/product_master_data/productMasterData';
import { Container } from '../../../../../../../../types/container';
import { DropdownSearchSelect } from '../../../../../../../components/Dropdown';
import { StockLocationContext } from '../../../../../../../../context/StockLocationContext';
import { StockLocationRole } from '../../../../../../../../types/stock_location_role_assignment';
import { CompanyContext } from '../../../../../../../../context/CompanyContext';
import { StockLocationRoleAssignmentContext } from '../../../../../../../../context/StockLocationRoleAssignmentContext';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../../types/translation/Translator';
import { ProcessTransactionProps } from '../ProcessOrderTransactionDefaultBody';
import { SystemStockLocation } from '../../../../../../../../types/stock_location/stockLocation';
import { ContainerContext } from '../../../../../../../../context/ContainerContext';

interface ProductTransactionDestinationStockLocationProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  productMasterData?: ProductMasterData;
  container?: Container;

  disabled?: boolean;

  props: ProcessTransactionProps;
}

export default function ProductTransactionDestinationStockLocation({
  transaction,
  setTransaction,
  productMasterData: pmd,
  disabled = false,
  container,
  props,
}: ProductTransactionDestinationStockLocationProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { stockLocations } = useContext(StockLocationContext);
  const { hasStockLocationRole } = useContext(StockLocationRoleAssignmentContext);

  const { containers } = useContext(ContainerContext);

  const toContainer = containers.get(props.toContainerId || '');
  const isVirtualContainer = toContainer?.stockLocationId === SystemStockLocation.id;

  if (transaction.type === ProductTransactionType.outbound || transaction.parentId) return null;

  const allowedStockLocations = [...stockLocations.values()].filter(
    item =>
      item.companyId === transaction.companyId &&
      hasStockLocationRole(currentCompany.id, item.id, StockLocationRole.STOCK_LOCATION_SUPERVISOR),
  );

  const isDisabled = disabled || (!!toContainer && !isVirtualContainer);

  return (
    <Grid item xs={6}>
      <DropdownSearchSelect
        disabled={isDisabled}
        mandatory
        items={allowedStockLocations}
        value={stockLocations.get(transaction.product.toStockLocationId || '')}
        textBuilder={item => item?.name || ''}
        label={t(TranslationKey.destinationStockLocation).singular.label}
        placeholder={t(TranslationKey.destinationStockLocation).singular.label}
        onSelect={item => {
          setTransaction(transaction => {
            let updated = transaction.withToStockLocationId(item?.id);
            if (toContainer) updated = updated.withToContainer(toContainer);
            return updated;
          });
        }}
      />
    </Grid>
  );
}
